import { rem } from 'polished';
import styled from 'styled-components';
import { HomePageOptionsCardStyled } from '../HomePageOptionsCardStyled';

export const HomePageOptionsCardStyledAP = styled(HomePageOptionsCardStyled)`
    .home-optionCard--image {
        max-width: ${rem(360)};
    }

    &.offer-card {
        .home-optionCard--image {
            transform: scaleX(-1);
        }
    }
`;
